import { useState } from "react";
import { Modal } from "risa-oasis-ui_v2";
import { ModalId } from "../../../enums/modalId";
import { ModalTitle } from "../../../enums/StringLiterals/modalTitle";
import { SideNavId } from "../../../enums/StringLiterals/sideNavId";
import { SideNavLabel } from "../../../enums/StringLiterals/sideNavLabel";
import SideNavElement from "../../sideNavElement/sideNavElement";
import AuthTab from "./components/authTab";
import SignedCopyTab from "./components/signedCopyTab";

interface TextNoteDocProps {
  onCancel: () => void;
  onSave: () => void;
  filePath: string;
  loading?: boolean;
  error?: string | null;
  signedScreenshotUrl: string;
  signedScreenshotLoading?: boolean;
  signedScreenshotError?: string | null;
  formattedTime: string;
}

const tabs = [
  { id: SideNavId.AUTH, label: SideNavLabel.AUTH },
  { id: SideNavId.SIGNED_COPY, label: SideNavLabel.SIGNED_COPY },
];

const TextNoteDoc = ({
  onCancel,
  onSave,
  filePath,
  loading,
  error = null,
  signedScreenshotUrl,
  signedScreenshotLoading,
  signedScreenshotError,
  formattedTime,
}: TextNoteDocProps) => {
  const [selectedTab, setSelectedTab] = useState<string>(SideNavId.AUTH);

  const renderContent = () => {
    switch (selectedTab) {
      case SideNavId.AUTH:
        return (
          <AuthTab
            filePath={filePath}
            loading={loading ?? false}
            error={error}
            formattedTime={formattedTime}
          />
        );
      case SideNavId.SIGNED_COPY:
        return (
          <SignedCopyTab
            filePath={signedScreenshotUrl}
            formattedTime={formattedTime}
            loading={signedScreenshotLoading ?? false}
            error={signedScreenshotError ?? null}
          />
        );
    }
  };
  return (
    <Modal
      dialogId={ModalId.TEXT_NOTE_DOC}
      title={ModalTitle.TEXT_NOTE_DOC}
      onClose={onCancel}
      onSave={onSave}
      saveButtonText="Save"
      cancelText="Cancel"
      heightPercentage={70}
      hideFooter={true}
    >
      <div className="flex h-full flex-col">
        <div className="flex flex-1 gap-1 overflow-hidden">
          <div className="side-nav--container flex w-[25%] flex-col overflow-y-auto">
            {tabs.map((tab) => (
              <SideNavElement
                key={tab.id}
                id={tab.id}
                label={tab.label}
                active={tab.id === selectedTab}
                onSelect={(id) => setSelectedTab(id)}
              />
            ))}
          </div>
          <div className="content--container flex h-full w-[75%] flex-1 flex-col bg-primaryGray-16 pb-3">
            {renderContent()}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default TextNoteDoc;
